import React from 'react';

const ErrorNotFound = () => (
  <div>
    404
  </div>
);

export default ErrorNotFound;



// WEBPACK FOOTER //
// ./src/pages/ErrorNotFoundPage.js